import axios from 'axios';
import errorHandler from './errorHandler.js';

const handleError = errorHandler().handleError;

export default function (baseUrl) {
  const url = baseUrl || 'http://localhost:8881';

  const conf = token => {
    return {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
  };

  async function saveMergeContent(accessToken, customer, mergeContent) {
    try {
      const path = `${url}/customers/${customer}/merge-contents`;
      const response = await axios.post(path, mergeContent, conf(accessToken));
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  }

  async function fetchMergeContents(
    accessToken,
    customer,
    {page = 0, pageSize = 10} = {}
  ) {
    try {
      const path = `${url}/customers/${customer}/merge-contents?page=${page}&size=${pageSize}`;
      const response = await axios.get(path, conf(accessToken));
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  }

  async function updateMergeContent(
    accessToken,
    customer,
    mergeContentId,
    mergeContent
  ) {
    try {
      const path = `${url}/customers/${customer}/merge-contents/${mergeContentId}`;
      const response = await axios.put(path, mergeContent, conf(accessToken));
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  }

  async function deleteMergeContent(accessToken, customer, mergeContentId) {
    try {
      const path = `${url}/customers/${customer}/merge-contents/${mergeContentId}`;
      await axios.delete(path, conf(accessToken));
    } catch (error) {
      throw handleError(error);
    }
  }

  async function retrieveMergeSource(accessToken, customer, mergeSource) {
    try {
      const path = `${url}/customers/${customer}/sources/${mergeSource}`;
      const response = await axios.get(path, conf(accessToken));
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  }

  return {
    saveMergeContent,
    fetchMergeContents,
    retrieveMergeSource,
    updateMergeContent,
    deleteMergeContent
  };
}
